<!-- TEMPLATE -->
<template>
  <div :class='servicesListClass'>
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns services-list'>
        <dean-section-title content='true'>
            <span slot='title'>
              <span class='avenir-heavy'>Diensten</span>
            </span>
        </dean-section-title>
        <dean-notification></dean-notification>
        <dean-table
            :data='servicesData'
            :columns='columns'
            :hover="true"
            @column-click='columnClick'
            @cell-click="cellClick"
        >
          <span slot="actions" slot-scope="actions" class="actions">
            <a v-if="actions.value.content.length"
               v-for="action in actions.value.content" class="action-link"
               :class="{disabled: action.disabled}"
               @click="!action.disabled ? actionClick(action) : {}">
              <div v-if="action.isVisible">
               <dean-icon
                   class="icon"
                   :glyph="action.icon"
                   width="20"
                   height="20"
               ></dean-icon>
                <span>{{ action.label }}</span>
              </div>
            </a>
            <span v-if="!actions.value.content.length">
              Geen acties beschikbaar
            </span>
          </span>
        </dean-table>
        <dean-pagination
            :current-page='servicesMetaData.pageNumber'
            :total-items='servicesMetaData.totalResults'
            :items-per-page='servicesMetaData.itemsPerPage'
            :select-items-per-page='selectItemsPerPage'
            :visible-pages='servicesMetaData.visiblePages'
            @page-changed='paginationChanged'
            @items-per-page='itemsPerPageChanged'
        >
        </dean-pagination>
        <transition name="fade" mode="out-in" v-if="isLoading">
          <dean-load-overlay class="table-overlay"></dean-load-overlay>
        </transition>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
// VUE
import {Component,} from 'vue-property-decorator';
import axios from 'axios';
import deanTableMixin from '@/mixins/deanTableMixin';
import {mixins} from 'vue-class-component';
import sideMenuCustomerMixin from '@/mixins/sideMenuCustomerMixin';
import {CollapseTransition} from 'vue2-transitions';


import {
  deanIcon,
  deanInputSelect,
  deanLoadOverlay,
  deanPagination,
  deanSearchField,
  deanSectionDivider,
  deanSectionTitle,
  deanSectionTitleItem,
  deanTable,
  goToIcon,
  infoIcon,
  plusIcon,
  switchIcon,
} from '@deanone/dean-components';
import {deanDialogBus} from '@/main';
import deanNotification from '@/components/deanComponents/deanNotification.vue';
import {getOvDate} from "@/mixins/dateWrapper";
import {ServiceTypeEnum} from "@/enums/ServiceTypeEnum";

@Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      deanIcon,
      deanNotification,
      deanLoadOverlay,
      CollapseTransition,
    },
  })
  export default class List extends mixins(deanTableMixin, sideMenuCustomerMixin) {

    public showSomething: boolean = false;
    public data: object[] = [];
    public isLoading: boolean = false;
    public currencyFormatter = new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR'});

    // COMPUTED
    get servicesListClass() {
      let value = 'address-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get servicesMetaData() {
      return this.pageMeta;
    }

    get servicesData() {
      return this.data;
    }

    public meta: object = {};

    public columns: any = {
      trait: {
        content: 'Kenmerk',
        align: 'left',
        sort: true,
        dql: 'trait',
      },
      description: {
        content: 'Omschrijving',
        align: 'left',
        sort: true,
        dql: 'description',
      },
      recurrentAmount: {
        content: 'Maandelijkse kosten',
        align: 'left',
        sort: true,
        dql: 'recurrentAmount',
      },
      startDate: {
        content: 'Begindatum',
        align: 'left',
        sort: true,
        dql: 'startDate',
      },
      actions: {
        content: 'Acties',
        type: 'slot',
        slot: 'actions',
        align: 'left',
        sort: true,
        dql: 'action',
      },
    };

    public partitionDetails: any = {
      partitionIdentifier: null,
      customerEmail: null,
      partitionName: null,
      serviceProviderName: null,
      url: null,
      startDate: null,
      status: null,
      pbxGroupId: null,
      provisionedServices: null,
      provisionedPhoneNumberRanges: null,
    };

    public tableName(): string {
      return 'customer-services';
    }

    public cellClick(target: { cell: {[key: string]: any}, row: { id: string, personId: string }, column: string }) {
      if (target.cell.slot === 'none' || target.cell.content.length === 0) {
        this.$router.push({
          name: 'customers.service.edit',
          params: {serviceId: target.row.id},
        });
      }
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      const url = '/-/trade/api/customer.services.list';

      axios
      .post('/-/trade/api/customer.info', {
        customerId: this.$route.params.pid,
      })
      .then(
          (customerInfoResponse: any) => {
            if (customerInfoResponse.data.partitionId) {
                return axios
                    .post('/-/trade/api/provisioning.partition.info', {
                      partitionId: customerInfoResponse.data.partitionId,
                    })
                    .catch(() => {
                      this.$toast(this.$store.state.main.notification.messages.provisioningNotAvailable);
                    });
            }
          }
      )
      .then(
          (partitionResponse: any) => {
              if (partitionResponse !== undefined) {
                const provisionedServices = this.provisionedServiceFactory(partitionResponse.data.PBXGroup);
                const provisionedPhoneNumberRanges = this.provisionedPhoneNumberRangesFactory(partitionResponse.data.PBXGroup);

                this.partitionDetails.partitionIdentifier = partitionResponse.data.identifier;
                this.partitionDetails.customerEmail = partitionResponse.data.customerEmail;
                this.partitionDetails.partitionName	= partitionResponse.data.partitionName;
                this.partitionDetails.serviceProviderName	= partitionResponse.data.serviceProviderName;
                this.partitionDetails.url	= partitionResponse.data.domain;
                this.partitionDetails.startDate = partitionResponse.data.creationDate ? getOvDate(partitionResponse.data.creationDate) : '-';
                this.partitionDetails.status = partitionResponse.data.status;
                this.partitionDetails.pbxGroupId = partitionResponse.data.PBXGroup? partitionResponse.data.PBXGroup.id : '-';
                this.partitionDetails.provisionedServices = provisionedServices ? provisionedServices : '-';
                this.partitionDetails.provisionedPhoneNumberRanges = provisionedPhoneNumberRanges ? provisionedPhoneNumberRanges : '-';
              }

            return axios.post(url, {
              meta: {
                startIndex: this.startIndex,
                numberOfItems: data.itemsPerPage,
              },
              customerId: this.$route.params.pid,
            })
          }
        )
        .then(
          (response) => {
            this.data = [];
            for (const service of response.data.data) {
              const actions: any[] = [];
              const serviceObj = {
                id: service.id,
                trait: service.trait ? service.trait :
                    service.mainProduct && service.mainProduct.product ?
                        service.mainProduct.product.name : '',
                description: service.name,
                recurrentAmount: service.mainProduct ?
                    this.currencyFormatter.format(service.mainProduct.recurrentAmount) : '-',
                startDate: service.mainProduct ? service.mainProduct.startDate : (service.startDate ? service.startDate : '-'),
                actions,
              };

              // Build up actions
              let additionalData = service.additionalData;

              if ((service.serviceType === ServiceTypeEnum.MOBILE_ODIDO || service.serviceType === ServiceTypeEnum.MOBILE_KPN) && service.mainProduct) {
                additionalData = service.mainProduct.additionalData;
              } else if (service.serviceType === ServiceTypeEnum.CLOUD || service.serviceType === ServiceTypeEnum.SIP_TRUNK) {
                additionalData = this.partitionDetails;
              }

              actions.push({
                type: 'properties',
                action: 'properties',
                isVisible: true,
                data: additionalData,
                label: 'Eigenschappen dienst',
                icon: infoIcon,
              });

              if (additionalData !== null) {
                switch (service.serviceType) {
                  case ServiceTypeEnum.CLOUD:
                  case ServiceTypeEnum.SIP_TRUNK:
                    const partitionName = this.partitionDetails.partitionName;
                    const hasUsername = (partitionName === null);
                    const loginAction: any = {
                      type: 'link',
                      action: 'loginMijn',
                      isVisible: true,
                      label: (hasUsername) ? 'Inloggen op cloud omgeving (geen partitie naam)' : 'Inloggen op cloud omgeving',
                      data: (hasUsername) ? null : {
                        username: partitionName,
                      },
                      disabled: (hasUsername),
                      icon: goToIcon,
                    };
                    actions.push(loginAction);
                    break;

                  case ServiceTypeEnum.CONNECTION:
                    break;

                  case ServiceTypeEnum.MOBILE_ODIDO:
                    actions.push({
                      type: 'addAdditionalProduct',
                      action: 'addAdditionalProduct',
                      isVisible: this.$store.getters.getUser.privileges.includes('update-customer-service'),
                      data: {
                        data: service,
                      },
                      label: 'Uitbreiding toevoegen',
                      icon: plusIcon,
                    });

                    actions.push({
                      type: 'changeProduct',
                      action: 'changeProduct',
                      isVisible: this.$store.getters.getUser.privileges.includes('update-customer-service'),
                      data: {
                        data: service,
                      },
                      label: 'Hoofdproduct wijzigen',
                      icon: switchIcon,
                    });

                    actions.push({
                      type: 'link',
                      action: 'openPartnerHub',
                      isVisible: true,
                      label: 'Partner hub @ Gamma',
                      disabled: false,
                      icon: goToIcon,
                    });

                    break;

                  case ServiceTypeEnum.MOBILE_KPN:
                    actions.push({
                      type: 'addAdditionalProduct',
                      action: 'addAdditionalProduct',
                      isVisible: this.$store.getters.getUser.privileges.includes('update-customer-service'),
                      data: {
                        data: service,
                      },
                      label: 'Uitbreiding toevoegen',
                      icon: plusIcon,
                    });

                    actions.push({
                      type: 'changeProduct',
                      action: 'changeProduct',
                      isVisible: this.$store.getters.getUser.privileges.includes('update-customer-service'),
                      data: {
                        data: service,
                      },
                      label: 'Hoofdproduct wijzigen',
                      icon: switchIcon,
                    });

                    actions.push({
                      type: 'link',
                      action: 'openPartnerHub',
                      isVisible: true,
                      label: 'Partner hub @ Gamma',
                      disabled: false,
                      icon: goToIcon,
                    });

                    break;
                }
              }

              // Push row to table
              this.data.push(serviceObj);
            }
            this.updateMeta(response.data.meta);
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        )
        .finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    public created() {
      this.loadList(this.pageMeta);
      this.buildSideMenuCustomer(this.$route.params.pid);
    }

    public showProperties(properties: any) {
      deanDialogBus.$emit('open', 'CustomerServicesProperties', {
        properties: properties ? properties : {},
      });
    }

    public addAdditionalProduct(serviceData: any) {
      deanDialogBus.$emit('open', 'CustomerServicesAddAdditionalProduct', {
        serviceData,
      });
    }

    public changeProduct(serviceData: any) {
      deanDialogBus.$emit('open', 'CustomerServicesChangeProduct', {
        serviceData,
      });
    }

    public actionClick(action: any) {
      switch (action.action) {
        case 'loginMijn':
          this.isLoading = true;
          axios.post('/-/trade/api/customer.application.clicktologin', {
            username: action.data.username,
            customerId: this.$route.params.pid,
          }).then(
            (response) => {
              window.open(response.data.data.url, '_blank');
            },
            (error) => {
              if (error.response.data?.errors?.length) {
                this.$toast({
                  text: 'Inloggen mislukt, de server antwoordde met de volgende foutmelding: ('
                    + error.response.status + ') '
                    + error.response.data.errors[0].message,
                  theme: 'danger',
                });
              }
            },
          ).finally(
            () => {
              this.isLoading = false;
            },
          );
          break;
        case 'openPartnerHub':
          this.isLoading = true;
          window.open('https://partnerhub.gammacommunications.nl/', '_blank');
          this.isLoading = false;
          break;
        case 'properties':
          this.showProperties(action.data);
          break;
        case 'addAdditionalProduct':
          this.addAdditionalProduct(action.data);
          break;
        case 'changeProduct':
          this.changeProduct(action.data);
          break;
      }
    }

    private provisionedServiceFactory(pbxGroup: any): string | null {
      if (!pbxGroup) {
        return null;
      }

      let provisionedServices = null;

      if (pbxGroup.provisionedServices) {
        provisionedServices = pbxGroup.provisionedServices.map((service: any) => service.name + ' ( ' + service.quantity + ' )');
      }

      return provisionedServices;
    }

    private provisionedPhoneNumberRangesFactory(pbxGroup:any): string | null {
      if (!pbxGroup || !pbxGroup.provisionedPhoneNumberRanges) {
        return null;
      }

      return pbxGroup.provisionedPhoneNumberRanges.map((range: any) => '(rangeStart: '+ range.from + '/rangeEnd: ' + range.to + ') ').join(' ,');
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';

  .services-list {
    position: relative;
  }

  .table-overlay {
    position: absolute;
    overflow: hidden;

    :deep(.dean-overlay) {
      position: absolute;
    }
  }

  :deep(td[data-label="Acties"]) {
    height: auto !important;
  }

  .actions {
    width: 100%;

    .action-link > div {
      display: flex;
      align-items: center;
      padding: 5px;

      .icon {
        margin-right: 5px;
        fill: #2c3e50;
        transition: fill .4s;
        cursor: pointer;
      }

      span {
        color: #2c3e50;
        transition: color .4s;
      }

      &:hover {
        .icon {
          fill: var(--color-secondary, $color-secondary);
        }

        span {
          color: var(--color-secondary, $color-secondary);
        }
      }
    }

    .action-link.disabled > div {
      .icon {
        fill: var(--color-dark-shade-4, $color-dark-shade-4);
      }

      span {
        color: var(--color-dark-shade-4, $color-dark-shade-4);
      }

      &:hover {
        .icon {
          fill: var(--color-dark-shade-4, $color-dark-shade-4);
        }

        span {
          color: var(--color-dark-shade-4, $color-dark-shade-4);
        }
      }
    }
  }
</style>

